import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from '@serengeti/serengeti-common';
import { map } from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GridaService {

  gridaEndPoint = 'https://aifrica-shinhan-poc.herokuapp.com/http://54.193.79.160:4567/post';
  private aiChatbotEndPoint = 'https://aifrica-shinhan-poc.herokuapp.com/http://110.45.179.38:8080/be.execute/backend/v1/execute/handle/chain/cba0eeab-8fce-4f49-9de3-ef4e1011fa05/';
  private endPoint = 'https://aifrica-shinhan-poc.herokuapp.com/http://110.45.179.38:8080/be.execute/backend/v1/execute/handle/chain/4b2c93cc-fd8e-4a92-a8a7-7f87d55dfb52/';
  // gridaEndPoint = 'http://localhost:3308/post';
  // private aiChatbotEndPoint = 'http://110.45.179.38:8080/be.execute/backend/v1/execute/handle/chain/cba0eeab-8fce-4f49-9de3-ef4e1011fa05/';
  // private endPoint = 'http://110.45.179.38:8080/be.execute/backend/v1/execute/handle/chain/4b2c93cc-fd8e-4a92-a8a7-7f87d55dfb52/';

  public resourceInfoList =
    '[{"filterType": "ResourceId","resourceType": "SerengetiService",' +
    '"requestBody": "voice","resultType": "application/json","async": false}]'; // input payload 형식

  public header = new HttpHeaders({
    'Accept': '*/*',
    'AccessKey': 'SerengetiAdministrationAccessKey',
    'SecretKey': 'SerengetiAdministrationSecretKey',
    'LoginId': 'administrator'
  });

  constructor(
    private messageService: MessageService,
    private http: HttpClient
  ) { }

  public generateImageToVoice(audioFile: any): Observable<any> {
    const body = new FormData();
    body.append('resourceInfoList', this.resourceInfoList);
    body.append('requestFiles', new File([audioFile], 'input.mp3'));
    return this.http.post(this.endPoint, body, {headers: this.header});
  }

  public generateAnswerToVoice(audioFile): Observable<any> {
    const body = new FormData();

    body.append('resourceInfoList', this.resourceInfoList);
    body.append('requestFiles', new File([audioFile], 'input.mp3'));
    return this.http.post(this.aiChatbotEndPoint, body, {headers: this.header});
  }

  public generateAnswerToText(text): Observable<any> {
    const body = new FormData();
    const resourceInfoList = '[{"filterType": "ResourceId","resourceType": "SerengetiService", "requestBody": "' + text
      + '","resultType": "application/json","async": false}]';

    body.append('resourceInfoList', resourceInfoList);
    body.append('requestText', text);
    return this.http.post(this.aiChatbotEndPoint, body, {headers: this.header});
  }

  public imageRegistration(sttRequests, imageFile): Observable<any> {
    const url = this.gridaEndPoint;

    const param = new FormData();
    param.append('image', imageFile);
    param.append('userName', sttRequests.userName);
    param.append('userEmail', sttRequests.userEmail);
    param.append('userPhone', sttRequests.userPhone);
    param.append('userOrganization', sttRequests.userOrganization);
    param.append('prompt', sttRequests.prompt);
    param.append('translatedPrompt', sttRequests.translatedPrompt);
    return this.http.post(url, param);
  }

  public updatePost(id: any, userRequest: any): Observable<any> {
    const url = this.gridaEndPoint;

    const param = new FormData();
    param.append('userName', userRequest.userName);
    param.append('userEmail', userRequest.userEmail);
    param.append('userPhone', userRequest.userPhone);
    param.append('userOrganization', userRequest.userOrganization);
    param.append('prompt', userRequest.prompt);
    param.append('translatedPrompt', userRequest.translatedPrompt);
    param.append('id', id);
    const body = {
      userName: userRequest.userName,
      userEmail: userRequest.userEmail,
      userPhone: userRequest.userPhone,
      userOrganization: userRequest.userOrganization,
      prompt: userRequest.prompt,
      translatedPrompt: userRequest.translatedPrompt,
      id: id
    };

    return this.http.put(url, body);
  }

  public getImageList(pageNumber): Observable<any> {
    const url = this.gridaEndPoint + '?page=' + pageNumber;

    return this.http.get(url);
  }

  public getPopularImageList(pageNumber): Observable<any> {
    const url = this.gridaEndPoint + '/like?page=' + pageNumber;

    return this.http.get(url);
  }

  public getDisApprovalImageList(pageNumber): Observable<any> {
    const url = this.gridaEndPoint + '/disapproval?page=' + pageNumber;

    return this.http.get(url);
  }

  public getRunCount(): Observable<any> {
    const url = this.gridaEndPoint + '/runCount';

    return this.http.get(url);
  }

  public addRunCount(): Observable<any> {
    const url = this.gridaEndPoint + '/addCount';

    return this.http.get(url);
  }

  public detail(imageId): Observable<any> {
    const url = this.gridaEndPoint + '/detail?id=' + imageId;

    return this.http.get(url);
  }

  public like(imageId): Observable<any> {
    const url = this.gridaEndPoint + '/like?id=' + imageId;

    return this.http.put(url, null);
  }

  public approval(imageId): Observable<any> {
    const url = this.gridaEndPoint + '/approval?id=' + imageId;

    return this.http.put(url, null);
  }

  public delete(imageId): Observable<any> {
    const url = this.gridaEndPoint + '?id=' + imageId;

    return this.http.delete(url);
  }

  getExcel(): Observable<any> {
    const url = this.gridaEndPoint + '/excel';
    return this.http.get(url, {responseType: 'blob'}
    ).pipe(map( res => res));
  }

  getGritalkCount(): Observable<any> {
    const url = this.gridaEndPoint + '/gritalkCount';
    return this.http.get(url);
  }

  addGritalkCount(): Observable<any> {
    const url = this.gridaEndPoint + '/addGritalkCount';
    return this.http.get(url);
  }
}
